import { Injectable, computed, inject, signal } from '@angular/core';
import { injectQuery, queryOptions } from '@ngneat/query';
import { derivedAsync } from 'ngxtension/derived-async';
import {
  OrderInvoicingStatusService,
  OrderInvoicingStatusPayload,
} from './order-invoicing-status.service';

@Injectable()
export class OrderInvoicingStatusState {
  private readonly query = injectQuery();
  private readonly orderInvoicingStatusService = inject(
    OrderInvoicingStatusService
  );

  readonly tenantId = signal<string | null>(null);
  readonly orderId = signal<string | null>(null);

  private getInvoicingStatusQueryOptions(payload: OrderInvoicingStatusPayload) {
    return queryOptions({
      queryKey: ['order-detail', 'order-invoicing-status', payload] as const,
      queryFn: async () =>
        await this.orderInvoicingStatusService.getInvoicingStatus(payload),
    });
  }

  readonly invoicingStatusQuery = derivedAsync(() => {
    const tenantId = this.tenantId();
    const orderId = this.orderId();

    if (!tenantId || !orderId) {
      return Promise.resolve(null);
    }

    const payload: OrderInvoicingStatusPayload = { tenantId, orderId };

    return this.query({
      ...this.getInvoicingStatusQueryOptions(payload),
      enabled: !!tenantId && !!orderId,
    }).result$;
  });

  readonly isInvoiced = computed(
    () => this.invoicingStatusQuery()?.data?.isInvoiced ?? false
  );
  readonly invoicedDate = computed(
    () => this.invoicingStatusQuery()?.data?.createdAt ?? null
  );
  readonly isLoading = computed(
    () => this.invoicingStatusQuery()?.isLoading ?? false
  );
  readonly error = computed(() => this.invoicingStatusQuery()?.error ?? null);

  setInvoicingParams(tenantId: string, orderId: string): void {
    this.tenantId.set(tenantId);
    this.orderId.set(orderId);
  }
}
